export default __webpack_public_path__ + "static/cyber-security1-b6e65cbb539f9c34d4a95706ae2c49ff.png";